/**
 * Sesión única: EventSource no permite cabeceras, así que las SSE que llevan licencia en el
 * query string añaden también el session_id (cookie 'session_id') como &sesion=...
 */
export function conSesionEnUrl(url: string, sesion: string | null | undefined): string {
  if (!sesion || !/[?&]licencia=/.test(url) || /[?&]sesion=/.test(url)) {
    return url;
  }
  return `${url}${url.includes('?') ? '&' : '?'}sesion=${encodeURIComponent(sesion)}`;
}
